import { render, staticRenderFns } from "./class-types-main.vue?vue&type=template&id=495dd5a4&"
import script from "./class-types-main.vue?vue&type=script&lang=js&"
export * from "./class-types-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports